<template>
	<inertia-head title="Bo Sanchez FREE Ebook - Seven Success Principles" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Thank you
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Discover the Seven Success Principles from the Ancient Book of Proverbs for Your Money, Work and Life
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				
				<div class="block block-rounded">
					<div class="block-content block-content-full text-center">
						<div class="mt-4 mb-5">
							<span class="text-white rounded p-2 h2" :class="{'bg-success':book.status=='S','bg-warning':book.status=='P','bg-danger':book.status=='F'}">
								<span v-if="book.status=='S'">Completed</span>
								<span v-if="book.status=='P'">Pending</span>
								<span v-if="book.status=='F'">Failed</span>
							</span>
						</div>
						<div v-if="book.status=='S'">
							<h3>Thank you, please allow us 5-10 business days to delivery your book.</h3>
							<h3>We will be also sending email updates.</h3>
						</div>
						<div v-else-if="book.status=='P'">
							<h3>Thank you, please follow the dragonpay email instructions.</h3>
						</div>
						<div v-else-if="book.status=='F'">
							<h3>Your transaction was failed.</h3>
						</div>
						<div class="mt-4">
							<inertia-link :href="'/delivery/freebook'+affiliate" class="btn btn-info">Go Back</inertia-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
			book 			: Object,
		},

		setup(props){

			const affiliate = ref('');
			
			if(props.book.affiliate_id!=null && props.book.affiliate_id!=0)
			{
				affiliate.value = '?aff='+props.book.affiliate_id;
			}

			return {
				affiliate
			}

		}
	}
</script>